import React, {useEffect, useState} from 'react';
import ProfileImage from "../../components/Profile/ProfileImage";
import ProfileField from "../../components/Profile/ProfileField";
import ProfileTextBox from "../../components/Profile/ProfileTextBox";
import Button from "../../components/Button";
import {StatusBadge, UserCode, Heading, Heading2} from "../../components/Profile/ProfileComponents";
import {useNavigate} from "react-router-dom";
import api from "../../api";
import {toPersianNumbers} from "../../utils/toPersianNumbers";
import {miladiToShamsi} from "../../utils/miladiToShamsi";

export default function CarrierProfile() {
  const [profile, setProfile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
  const fetchProfile = async () => {
    const token = localStorage.getItem("accessToken");

    // ۱️⃣ اگر توکن در localStorage وجود ندارد → یعنی کاربر لاگین نکرده
    if (!token) {
      navigate("/user-login/");
      return;
    }

    try {
      const response = await api.get(
        "accounts/carrier/profile/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setProfile(response.data);
    } catch (error) {
      console.error("خطا در گرفتن پروفایل:", error);

      // ۲️⃣ اگر خطای 401 (توکن نامعتبر یا منقضی‌شده) دریافت شد → هدایت به لاگین
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("accessToken");
        navigate("/user-login/");
      }
    }
  };

  fetchProfile();
}, [navigate]);

  if (!profile) return (
    <div className="flex justify-center items-center h-64">
      <p className="text-lg text-gray-600">در حال بارگذاری...</p>
    </div>
  );
  console.log("User data:", profile);

  return (
      <div className="p-6">

        {/* محتوای اصلی */}
        <div className="mb-8">


            {/* --- بخش بالای پروفایل --- */}
            <div className="flex flex-col md:flex-row items-start gap-6 mb-8 border-b border-gray-200 pb-8">
              {/* عکس پروفایل */}
              <ProfileImage src={profile.logo} />

              {/* اطلاعات کناری عکس */}
              <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
                {/* ستون ۱: نام و نام خانوادگی */}
                <div>
                    <Heading title={profile.full_name} placeHolder={"نام و نام خانوادگی"}/>
                    <Heading2 title={profile.title} placeHolder={"توسعه دهنده بازارگاه کالاهای ساختمانی"}/>
                </div>

                {/* ستون ۲: وضعیت فعال بودن + کد مشتری */}
                <div className="flex flex-col items-start sm:items-end gap-2">
                  <StatusBadge isActive={profile.user.is_active}/>
                  <UserCode label= {'کد کاربری'} code={toPersianNumbers(profile.carrier_code)}/>

                </div>
              </div>
            </div>

            {/* --- باکس متن معرفی --- */}
            <Heading title={"معرفی"}/>
            <ProfileTextBox text={profile.description} />

            {/* --- مشخصات کاربر --- */}
            <div className="mb-10">
              <h3 className="text-lg font-bold text-gray-800 mb-4 border-b border-gray-200 pb-2">
                مشخصات کاربر
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                  <ProfileField label="شماره موبایل" value={toPersianNumbers(profile.user.phone_number)} />
                  <ProfileField label="ایمیل" value={profile.email} />
                  <ProfileField label="کد ملی" value={toPersianNumbers(profile.national_id)} />
                  <ProfileField label="تاریخ تولد" value={toPersianNumbers(miladiToShamsi(profile.birth_date))} />
                  <ProfileField label="شماره موبایل دوم" value={toPersianNumbers(profile.secondary_phone)} />
                  <ProfileField
                    label="وضعیت احراز هویت"
                    value={profile.kyc_status === "verified" ? "تأیید شده" : "تأیید نشده"}
                  />
              </div>
            </div>

            {/* --- مشخصات سازمان (در صورت وجود) --- */}
            {profile.is_legal_entity && (
                <div className="mb-10">
                  <h3 className="text-lg font-bold text-gray-800 mb-4 border-b border-gray-200 pb-2">
                    مشخصات سازمان
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                      <ProfileField label="نام سازمان" value={profile.org_name} />
                      <ProfileField label="کد اقتصادی" value={toPersianNumbers(profile.economic_code)} />
                      <ProfileField label="شناسه ملی" value={toPersianNumbers(profile.national_legal_id)} />
                      <ProfileField label="شماره ثبت" value={toPersianNumbers(profile.registration_id)} />
                      <ProfileField label="استان" value={profile.province} />
                      <ProfileField label="شهر" value={profile.city} />
                      <ProfileField label="تلفن ثابت دفتر" value={toPersianNumbers(profile.office_phone)} />
                      <ProfileField label="مدیر عامل / نماینده" value={profile.representative_name} />
                      <ProfileField label="شماره موبایل مدیر عامل" value={toPersianNumbers(profile.representative_phone)} />
                      <ProfileField label="ایمیل سازمانی" value={profile.org_email} />

                  </div>
                </div>
            )}

            {/* --- دکمه‌های انتهایی --- */}
            <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
                <Button children={'ویرایش پروفایل'} onClick={() => navigate("/carrier-panel/carrier-profile-edit/")}/>
                <Button variant={'secondary'} children={'بازگشت به پنل'} onClick={() => navigate("/")}/>
            </div>
          </div>

      </div>

        );
        }